import { TableHead, TableRow, TableCell, Typography } from '@mui/material';
import React from 'react';

export const TaskTableHead = ({ currHeaders }) => {
  return (
    <TableHead>
      <TableRow>
        {currHeaders.map((currHeader) => {
          return (
            <TableCell
              key={currHeader.id}
              align="center"
              sx={{ minWidth: '125px' }}
            >
              <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                {currHeader.title}
              </Typography>
            </TableCell>
          );
        })}
      </TableRow>
    </TableHead>
  );
};
